import styled from 'styled-components';
import { Link } from 'react-router-dom';

export default styled(Link)`
  text-decoration: none;
  width: ${({ tabnav }) => tabnav ? '100%' : 'unset'};
  outline: none;
`;


// WEBPACK FOOTER //
// ./src/components/Link/Link.js